import {
  ArrowLeftIcon,
  Button,
  CheckIcon,
  Heading,
  Paragraph,
  Popup,
  TriangleExclamationIcon,
  Checkbox,
  Label,
} from '@quickmd-llc/design-system'
import React, { useCallback, useState } from 'react'
import { setDontShowCompleteConfirmation } from './utils'

type ConfirmVisitCompletionModalProps = {
  isOpen: boolean
  onClose: () => void
  onComplete: () => void
}
export const ConfirmVisitCompletionModal: React.FC<ConfirmVisitCompletionModalProps> = ({
  isOpen,
  onClose,
  onComplete,
}: ConfirmVisitCompletionModalProps) => {
  const [dontShow, setDontShow] = useState<boolean>(false)

  const handleToggle = useCallback((checked: boolean) => {
    setDontShow(checked)
    setDontShowCompleteConfirmation(checked)
  }, [])

  return (
    <Popup
      onClose={onClose}
      isOpen={isOpen}
      showCloseIcon
      styles={{
        wrapperClassName: '!w-[500px] ',
        containerClassName: ' w-full ',
      }}
      header={{
        content: (
          <Heading level='h3' className='flex items-center gap-sp-1'>
            <TriangleExclamationIcon iconSize='l' /> Confirm visit completion
          </Heading>
        ),
      }}
      body={
        <div className='w-full max-w-md rounded-lg bg-white'>
          <Paragraph className='text-text-medium'>
            Completing a visit cannot be undone. Your original note will become uneditable, and any change must be done
            through addendums.
          </Paragraph>

          <div
            className='mt-sp-3 flex cursor-pointer items-center'
            onClick={() => handleToggle(!dontShow)}
            role='presentation'>
            <Checkbox checked={dontShow} onChange={handleToggle} />
            <Label className='text-sm'>Don’t show this confirmation again</Label>
          </div>
        </div>
      }
      footer={
        <div className='flex justify-end gap-sp-2'>
          <Button priority='secondary' onClick={onClose}>
            <ArrowLeftIcon />
            Go back and edit
          </Button>

          <Button priority='primary' onClick={onComplete}>
            <CheckIcon />
            Yes, complete the visit
          </Button>
        </div>
      }
    />
  )
}
